export const normalizeFilePath = (path) => {
  return path.replace(/\./g, "___");
};

// Starter repos were processed with an older encoding that used single underscores
// for dots. This helper looks up a file summary key using both encodings.
export const lookupFileSummary = (fileSummaries, path) => {
  if (!fileSummaries) return undefined;
  const tripleKey = path.replace(/\./g, "___");
  if (tripleKey in fileSummaries) return fileSummaries[tripleKey];
  const singleKey = path.replace(/\./g, "_");
  if (singleKey in fileSummaries) return fileSummaries[singleKey];
  return undefined;
};

export const hasFileSummaryKey = (fileSummaries, path) => {
  if (!fileSummaries) return false;
  const tripleKey = path.replace(/\./g, "___");
  if (tripleKey in fileSummaries) return true;
  const singleKey = path.replace(/\./g, "_");
  return singleKey in fileSummaries;
};
